import React, { useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Form, Input } from "antd";
import CrudButtons from "components/button/crudbuttons";
import FormItem from "components/fields/FormItem";
import { 
  getEmployeeSettingList, 
  doEmployeeSettingUpdate 
} from "../../../../../redux/employee/employeeState";
import SwitchField from "components/fields/SwitchField";
import { MODULE_EMPLOYEES } from "variables/constants";

const SettingForm = ({ 
	recordData, 
	getRecord,
	doUpdate, 
	onCancel, 
	submitLabel,
	employeeId,
	doCreate,
	getList,
	settings,
	parentId,
	...props
}) => {

	const [form] = Form.useForm();
	const { mode } = props;
	

	useEffect(() => {
		if (employeeId) {
			getList({ parentId: employeeId, class: 'employee' });
		}
	}, [employeeId, getList]);

	useEffect(() => {
		if (settings?.length > 0) {
			const initialValues = {
				parentId,
				settings: settings.map(item => ({
					set_id: item.set_id,
					set_item_id: item.set_item_id,
					set_value: item.setting_item?.sit_input_field === "switch"
						? item.set_value === "1"
						: item.set_value, 
				})),
			};
			form.setFieldsValue(initialValues);
		}
	}, [settings, form, parentId]);

	const onSubmit = (formData)=> {
	try {
		const payload = {
			parentId: employeeId,
			class: "employee",
			settings: formData?.settings.map((item) => ({
				set_id: item.set_id,
				set_item_id: item.set_item_id,
  				set_value: item.set_value,
				})),
		}; 
		payload.settingId = payload.settings[0].set_id;

		console.log("payload:", payload);

		doUpdate(payload);
		} catch (error) {
		console.error("Save failed:", error);
		}
	};

	return (
		<Form className="form" 
			layout="horizontal" 
			form={form} 
			onFinish={onSubmit}
		>
			<FormItem 
				name="parentId" 
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="mb-4 grid grid-cols-4 gap-y-2 gap-x-4 px-2 w-full">
				{Array.isArray(settings) &&settings?.map((item, index) => (
					<Fragment key={item?.set_item_title}>
						<div className="flex items-center font-medium label-title dark:text-white">
							{item?.set_item_title}
						</div>
						<div>
							<FormItem 
								name={['settings', index, 'set_id']}
								noStyle
							>
								<Input type="hidden" value={item?.set_id}/>
							</FormItem>
							<FormItem 
								name={['settings', index, 'set_item_id']}
								noStyle
							>
								<Input type="hidden" value={item?.set_item_id}/>
							</FormItem>
							<FormItem 
								name={['settings', index, 'set_value']}
								noStyle
							>
								{item?.setting_item?.sit_input_field === "switch" ? (
									<SwitchField
										id={`settings-${index}-value`}
										mode="edit"
										type="text"
										labelYes="Yes"
										labelNo="No"
									/>
								) : (
									<Input
										id={`settings-${index}-value`}
										className="input-field"
										maxLength={20}
										style={{
											width: "43.4%",
										}}
									/>
								)}
							</FormItem>
						</div>
					</Fragment>
				))}
			</div>
			

			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}     
						isModal={true}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Update"
						moduleId={MODULE_EMPLOYEES}
					/>
				)}
			</div>
		</Form>
	);
};

const mapStateToProps = (state) => ({
  settings: state.employee.employeeSettingList?.items || [],
});

const mapDispatchToProps = (dispatch) => ({
  getList: (payload) => dispatch(getEmployeeSettingList(payload)),
  doUpdate: (payload) => dispatch(doEmployeeSettingUpdate(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingForm);
